import { CustomerInterfaceConfigurationKey } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllCustomerInterfaceConfigurationKeys = () =>
  getAllEnumOptions(CustomerInterfaceConfigurationKey)

export const getCustomerInterfaceConfigurationKeysLabel = (
  key?: CustomerInterfaceConfigurationKey,
) => {
  if (key === null || typeof key === 'undefined') return ''

  return CustomerInterfaceConfigurationKey[key]
}
